<template>
    <SafetyPolicies></SafetyPolicies>
</template>

<script>
import { defineAsyncComponent } from "vue";

const GuestLayout = defineAsyncComponent(() =>
    import("../../Layouts/GuestLayout.vue")
);
const SafetyPolicies = defineAsyncComponent(() =>
    import("../../components/Safety/SafetyPolicies.vue")
);

export default {
    name: "SafetyPoliciesUnauth", //The name you are in should not equal the name of the component you are importing.
    components: { SafetyPolicies, GuestLayout },
    layout: [GuestLayout],
};
</script>
